import { formatDate } from "utils/formatDate";
import {
  DetectedFilingCartItem,
  DetectedFilingCartItemsBySeason,
  DetectedFilingsResponse,
} from "v2/store/taxSetupApi";
import { FilingNode, SeasonFilings } from "v2/types/filingsDashboard.types";
import { FILING_GROUP_ORDER } from "v2/constants/filingGroup";
import { toFilingGroup } from "v2/utils/toFilingGroup";

const EMPTY_CART_ITEMS: DetectedFilingCartItemsBySeason = {};

export const formatUsd = (amount: number): string =>
  `$${amount.toLocaleString("en-US")}`;

const filingTitle = (item: DetectedFilingCartItem): string => {
  const base = item.product_details.product_name;
  return item.quantity > 1 ? `${base} × ${item.quantity}` : base;
};

const toFilingNode = (
  item: DetectedFilingCartItem,
  season: string
): FilingNode => ({
  id: item.uuid,
  title: filingTitle(item),
  group: toFilingGroup(item.group),
  description: item.description ?? undefined,
  dueDate: item.deadline ? formatDate(item.deadline) : undefined,
  isOverdue: item.is_overdue,

  action: item.is_overdue
    ? { kind: "pay", label: `Pay ${formatUsd(item.total)}` }
    : { kind: "cart", label: formatUsd(item.total) },
  cartItemId: item.uuid,
  productId: item.product_details.product_id,
  productContentTypeId: item.product_details.product_content_type_id,
  stateId: item.product_details.state?.state_id,
  paymentAmount: item.total,
  season,
  status: item.status,
});

const seasonRank = (season: string): number => {
  const year = Number(season);
  return Number.isNaN(year) ? -Infinity : year;
};

export const groupFilingsBySeason = (
  response: DetectedFilingsResponse | undefined
): SeasonFilings[] =>
  Object.entries(response?.cart_items ?? EMPTY_CART_ITEMS)

    .filter(([, items]) => items.length > 0)
    .sort(([a], [b]) => seasonRank(b) - seasonRank(a))
    .map(([season, items]) => ({
      season,
      filings: items
        .map((item) => toFilingNode(item, season))
        .sort(
          (a, b) =>
            FILING_GROUP_ORDER.indexOf(a.group) -
            FILING_GROUP_ORDER.indexOf(b.group)
        ),
    }));
